'use strict';

intellidealerAppCoreModule.factory('multimediaResource', function ($resource, appConfigurationService) {
  var resource = {};
  resource.pictureLocations = $resource(appConfigurationService.basePath + '/rest/multimedia/myDealerMultimediaByModuleAndKey/');
  return resource;
});
